var _defs, _rect, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIconWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Success_Icon",
    "data-name": "Success Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #f8f8f8;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        fill: #58b947;\n      }\n\n      .cls-4, .cls-5 {\n        stroke: none;\n      }\n\n      .cls-5 {\n        fill: #58b947;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4903",
    "data-name": "Rectangle 4903",
    className: "cls-1",
    width: 32,
    height: 32
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_10820",
    "data-name": "Path 10820",
    className: "cls-2",
    transform: "translate(8 6.994)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M 8 15.25600051879883 C 4.002339839935303 15.25600051879883 0.75 12.00366020202637 0.75 8.006000518798828 C 0.75 4.008340358734131 4.002339839935303 0.7560005187988281 8 0.7560005187988281 C 11.99765968322754 0.7560005187988281 15.25 4.008340358734131 15.25 8.006000518798828 C 15.25 12.00366020202637 11.99765968322754 15.25600051879883 8 15.25600051879883 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M 8 1.506000518798828 C 4.415889739990234 1.506000518798828 1.5 4.421890258789062 1.5 8.006000518798828 C 1.5 11.59011077880859 4.415889739990234 14.50600051879883 8 14.50600051879883 C 11.58411026000977 14.50600051879883 14.5 11.59011077880859 14.5 8.006000518798828 C 14.5 4.421890258789062 11.58411026000977 1.506000518798828 8 1.506000518798828 M 8 0.006000518798828125 C 12.41800022125244 0.006000518798828125 16 3.588000297546387 16 8.006000518798828 C 16 12.42400074005127 12.41800022125244 16.00600051879883 8 16.00600051879883 C 3.581999778747559 16.00600051879883 0 12.42400074005127 0 8.006000518798828 C 0 3.588000297546387 3.581999778747559 0.006000518798828125 8 0.006000518798828125 Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10821",
    "data-name": "Path 10821",
    className: "cls-3",
    d: "M4.717,8.381l.761-.761L6.909,9.053l3.613-3.614.761.761L6.909,10.573Z",
    transform: "translate(8 6.994)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIconWhite);
export default __webpack_public_path__ + "static/media/success-icon-white.a1834a15b5e1c5f0a7b3c843b57bbc98.svg";
export { ForwardRef as ReactComponent };